import { render, staticRenderFns } from "./DocumentosComerciales.vue?vue&type=template&id=9bc710f6&"
import script from "./DocumentosComerciales.vue?vue&type=script&lang=js&"
export * from "./DocumentosComerciales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports